import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface LanguageContextType {
  language: Language | null;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const translations = {
  es: {
    // Header
    'nav.home': 'Inicio',
    'nav.services': 'Servicios',
    'nav.comparison': 'Comparación',
    'nav.advantages': 'Ventajas',
    'nav.process': 'Proceso',
    'nav.contact': 'Contacto',
    'nav.cta': 'Contáctanos',
    'nav.openMenu': 'Abrir menú',
    'nav.closeMenu': 'Cerrar menú',
    // Hero
    'hero.title1': 'ESTRUCTURAS METÁLICAS',
    'hero.title2': '— y —',
    'hero.title3': 'ARCOTECHOS',
    'hero.subtitle': 'Fabricamos techos y estructuras metálicas con más de 10 años de experiencia en la región. La alternativa profesional, rápida y económica frente a la construcción tradicional.',
    'hero.cta': 'Solicita tu Cotización',
    // Services
    'services.title': 'Nuestros Servicios',
    'services.subtitle': 'Especialistas en diseño, fabricación y montaje de todo tipo de cubiertas y estructuras metálicas.',
    'services.card1.title': 'Techos Curvos (Sin Estructura)',
    'services.card1.desc': 'Cubiertas de lámina rolada que se apoyan sobre muros existentes. Ideales para canchas, bodegas y patios.',
    'services.card2.title': 'Techos Autosoportantes',
    'services.card2.desc': 'Arcos de lámina que nacen desde el piso, formando paredes y techo en una sola pieza. Máxima economía y rapidez.',
    'services.card3.title': 'Techos Curvos (Con Estructura)',
    'services.card3.desc': 'Arcotechos apoyados sobre columnas y trabes metálicas fabricadas a medida. Mayor altura y resistencia.',
    'services.card4.title': 'Techos a 2 Aguas',
    'services.card4.desc': 'Cubiertas tradicionales a dos pendientes con estructura metálica. Perfectas para naves industriales y almacenes.',
    'services.card5.title': 'Estructuras Metálicas',
    'services.card5.desc': 'Diseño y fabricación de naves industriales, bodegas, mezanines y plataformas estructurales completas.',
    'services.card6.title': 'Herrería en General',
    'services.card6.desc': 'Fabricación de puertas, portones, barandales, escaleras y trabajos especiales a medida.',
    'services.card7.title': 'Domos',
    'services.card7.desc': 'Cubiertas translúcidas con estructura metálica para patios, terrazas y tragaluces. Iluminación natural.',
    // Comparison
    'comp.title': '¿Por Qué Elegir Estructura Metálica en Lugar de Losa de Concreto?',
    'comp.subtitle': 'Conoce las diferencias clave y descubre por qué el acero es la opción inteligente para tu próximo proyecto.',
    'comp.feature': 'Característica',
    'comp.metal': 'Estructura Metálica',
    'comp.concrete': 'Losa de Concreto',
    'comp.f1.name': 'Costo',
    'comp.f1.metal': 'Hasta 30-40% más económico',
    'comp.f1.concrete': 'Mayor costo en materiales y mano de obra',
    'comp.f2.name': 'Tiempo de construcción',
    'comp.f2.metal': '2 a 4 meses',
    'comp.f2.concrete': '6 a 12 meses',
    'comp.f3.name': 'Peso',
    'comp.f3.metal': 'Ligero, menos carga en cimentación',
    'comp.f3.concrete': 'Pesado, requiere cimentación más robusta',
    'comp.f4.name': 'Claros y alturas',
    'comp.f4.metal': 'Permite grandes claros sin columnas intermedias, alturas libres mayores',
    'comp.f4.concrete': 'Limitado en claros, requiere más apoyos',
    'comp.f5.name': 'Mantenimiento',
    'comp.f5.metal': 'Bajo mantenimiento con tratamiento anticorrosivo',
    'comp.f5.concrete': 'Puede presentar fisuras, filtraciones',
    'comp.f6.name': 'Versatilidad',
    'comp.f6.metal': 'Fácil de ampliar, modificar o reubicar',
    'comp.f6.concrete': 'Difícil de modificar una vez construido',
    'comp.f7.name': 'Sustentabilidad',
    'comp.f7.metal': '100% reciclable',
    'comp.f7.concrete': 'Difícil de reciclar',
    // Advantages
    'adv.title': 'Ventajas de las Estructuras Metálicas',
    'adv.1.title': 'Rapidez de instalación',
    'adv.1.desc': 'Tu proyecto listo en un par de meses. El montaje es ágil y limpio.',
    'adv.2.title': 'Menor costo total',
    'adv.2.desc': 'Ahorra en materiales, mano de obra y cimentación gracias a su ligereza.',
    'adv.3.title': 'Grandes claros libres',
    'adv.3.desc': 'Espacios amplios sin columnas intermedias que estorben tu operación.',
    'adv.4.title': 'Mayor altura útil',
    'adv.4.desc': 'Aprovecha todo el volumen de tu construcción para almacenamiento o maquinaria.',
    'adv.5.title': 'Durabilidad',
    'adv.5.desc': 'Resistente al clima y condiciones de tu localidad, con un mantenimiento mínimo.',
    'adv.6.title': 'Adaptabilidad',
    'adv.6.desc': 'Fácil de ampliar, modificar o incluso desmontar en el futuro.',
    // Process
    'proc.title': 'Nuestro Proceso',
    'proc.1.title': '1. Consulta inicial',
    'proc.1.desc': 'Escuchamos tu proyecto y necesidades.',
    'proc.2.title': '2. Propuesta técnica',
    'proc.2.desc': 'Diseño y presupuesto detallado sin compromiso.',
    'proc.3.title': '3. Fabricación',
    'proc.3.desc': 'Producción especializada en nuestro taller.',
    'proc.4.title': '4. Entrega',
    'proc.4.desc': 'Instalación y entrega en tiempo y forma.',
    // Contact
    'contact.title': 'Cotiza Tu Proyecto',
    'contact.subtitle': 'Cuéntanos qué necesitas y te damos una propuesta sin compromiso.',
    'contact.email': 'Correo Electrónico',
    'contact.phone': 'Teléfonos',
    'contact.location': 'Ubicación',
    'contact.map': 'Ver Ubicación en Mapa',
    'contact.trust1.title': 'Empresa legalmente constituida',
    'contact.trust1.desc': 'Operando formalmente, ofreciendo garantías reales en cada proyecto.',
    'contact.trust2.title': 'Más de 10 años en la región',
    'contact.trust2.desc': 'Conocemos la Mixteca, sus condiciones y la logística necesaria para cumplir en tiempo.',
    'contact.quote': '"La empresa que construye contigo — no solo para ti."',
    // Footer
    'footer.privacy': 'Aviso de Privacidad',
    'footer.terms': 'Términos y Condiciones',
    'footer.rights': 'Todos los derechos reservados.',
    'footer.close': 'Cerrar',
    // Privacy Modal
    'priv.updated': 'Última actualización: Enero 2025',
    'priv.1.title': '1. Responsable del tratamiento de datos',
    'priv.1.desc': 'ARCO Techos y Estructuras de la Mixteca, con domicilio en Calle 2 de Abril #134, Colonia Antonio de León, Huajuapan de León, Oaxaca, México, es responsable del tratamiento de sus datos personales.',
    'priv.2.title': '2. Datos personales que recabamos',
    'priv.2.desc': 'Podemos recabar los siguientes datos personales: nombre completo, número de teléfono, correo electrónico, dirección y datos relacionados con su proyecto de construcción o remodelación.',
    'priv.3.title': '3. Finalidad del tratamiento',
    'priv.3.desc': 'Sus datos personales serán utilizados para: brindar cotizaciones, dar seguimiento a proyectos, enviar información sobre nuestros servicios y mantener comunicación relacionada con los trabajos contratados.',
    'priv.4.title': '4. Protección de datos',
    'priv.4.desc': 'Implementamos medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales contra daño, pérdida, alteración, destrucción o uso no autorizado.',
    'priv.5.title': '5. Derechos ARCO',
    'priv.5.desc': 'Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, puede contactarnos al correo electrónico itzelrojasramirez51@gmail.com.',
    'priv.6.title': '6. Contacto',
    'priv.6.desc': 'Para cualquier duda o aclaración sobre este aviso de privacidad, puede comunicarse con nosotros al correo itzelrojasramirez51@gmail.com o a los teléfonos 953 151 3525 y 953 212 7674.',
    // Terms Modal
    'terms.updated': 'Última actualización: Enero 2025',
    'terms.1.title': '1. Aceptación de los términos',
    'terms.1.desc': 'Al utilizar este sitio web, usted acepta los presentes términos y condiciones. Si no está de acuerdo con alguno de ellos, le pedimos no utilizar este sitio.',
    'terms.2.title': '2. Servicios ofrecidos',
    'terms.2.desc': 'ARCO Techos y Estructuras de la Mixteca ofrece servicios de diseño, fabricación e instalación de estructuras metálicas, arcotechos, techos curvos, herrería y domos. Las cotizaciones proporcionadas son estimaciones sujetas a confirmación tras la evaluación del proyecto.',
    'terms.3.title': '3. Cotizaciones y precios',
    'terms.3.desc': 'Los precios y cotizaciones son válidos por el periodo especificado en cada documento. Los precios pueden variar según las condiciones del mercado, materiales y especificaciones del proyecto.',
    'terms.4.title': '4. Propiedad intelectual',
    'terms.4.desc': 'Todo el contenido de este sitio web, incluyendo textos, imágenes, logotipos y diseños, es propiedad de ARCO Techos y Estructuras de la Mixteca y está protegido por las leyes de propiedad intelectual aplicables.',
    'terms.5.title': '5. Limitación de responsabilidad',
    'terms.5.desc': 'La información contenida en este sitio web es de carácter informativo. ARCO Techos y Estructuras de la Mixteca no se hace responsable por decisiones tomadas con base en la información aquí presentada sin una consulta previa directa.',
    'terms.6.title': '6. Contacto',
    'terms.6.desc': 'Para cualquier consulta sobre estos términos, puede comunicarse con nosotros al correo itzelrojasramirez51@gmail.com o a los teléfonos 953 151 3525 y 953 212 7674.'
  },
  en: {
    // Header
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.comparison': 'Comparison',
    'nav.advantages': 'Advantages',
    'nav.process': 'Process',
    'nav.contact': 'Contact',
    'nav.cta': 'Contact Us',
    'nav.openMenu': 'Open menu',
    'nav.closeMenu': 'Close menu',
    // Hero
    'hero.title1': 'METAL STRUCTURES',
    'hero.title2': '— & —',
    'hero.title3': 'CURVED ROOFS',
    'hero.subtitle': 'We manufacture metal roofs and structures with over 10 years of experience in the region. The professional, fast, and economical alternative to traditional construction.',
    'hero.cta': 'Request a Quote',
    // Services
    'services.title': 'Our Services',
    'services.subtitle': 'Specialists in the design, manufacture, and assembly of all types of metal roofs and structures.',
    'services.card1.title': 'Curved Roofs (No Structure)',
    'services.card1.desc': 'Rolled sheet roofs supported on existing walls. Ideal for sports courts, warehouses, and patios.',
    'services.card2.title': 'Self-Supporting Roofs',
    'services.card2.desc': 'Sheet metal arches rising from the floor, forming walls and roof in a single piece. Maximum economy and speed.',
    'services.card3.title': 'Curved Roofs (With Structure)',
    'services.card3.desc': 'Curved roofs supported on custom-made metal columns and beams. Greater height and resistance.',
    'services.card4.title': 'Gabled Roofs',
    'services.card4.desc': 'Traditional two-slope roofs with metal structure. Perfect for industrial buildings and warehouses.',
    'services.card5.title': 'Metal Structures',
    'services.card5.desc': 'Design and manufacture of industrial buildings, warehouses, mezzanines, and complete structural platforms.',
    'services.card6.title': 'General Ironwork',
    'services.card6.desc': 'Manufacture of doors, gates, railings, stairs, and custom special works.',
    'services.card7.title': 'Domes',
    'services.card7.desc': 'Translucent roofs with metal structure for patios, terraces, and skylights. Natural lighting.',
    // Comparison
    'comp.title': 'Why Choose Metal Structure Instead of Concrete Slab?',
    'comp.subtitle': 'Learn the key differences and discover why steel is the smart choice for your next project.',
    'comp.feature': 'Feature',
    'comp.metal': 'Metal Structure',
    'comp.concrete': 'Concrete Slab',
    'comp.f1.name': 'Cost',
    'comp.f1.metal': 'Up to 30-40% more economical',
    'comp.f1.concrete': 'Higher cost in materials and labor',
    'comp.f2.name': 'Construction time',
    'comp.f2.metal': '2 to 4 months',
    'comp.f2.concrete': '6 to 12 months',
    'comp.f3.name': 'Weight',
    'comp.f3.metal': 'Lightweight, less load on foundation',
    'comp.f3.concrete': 'Heavy, requires more robust foundation',
    'comp.f4.name': 'Spans and heights',
    'comp.f4.metal': 'Allows large spans without intermediate columns, greater clear heights',
    'comp.f4.concrete': 'Limited in spans, requires more supports',
    'comp.f5.name': 'Maintenance',
    'comp.f5.metal': 'Low maintenance with anti-corrosive treatment',
    'comp.f5.concrete': 'May present cracks, leaks',
    'comp.f6.name': 'Versatility',
    'comp.f6.metal': 'Easy to expand, modify or relocate',
    'comp.f6.concrete': 'Difficult to modify once built',
    'comp.f7.name': 'Sustainability',
    'comp.f7.metal': '100% recyclable',
    'comp.f7.concrete': 'Difficult to recycle',
    // Advantages
    'adv.title': 'Advantages of Metal Structures',
    'adv.1.title': 'Installation speed',
    'adv.1.desc': 'Your project ready in a couple of months. Assembly is agile and clean.',
    'adv.2.title': 'Lower total cost',
    'adv.2.desc': 'Save on materials, labor, and foundation thanks to its lightness.',
    'adv.3.title': 'Large clear spans',
    'adv.3.desc': 'Wide spaces without intermediate columns that hinder your operation.',
    'adv.4.title': 'Greater useful height',
    'adv.4.desc': 'Take advantage of the entire volume of your construction for storage or machinery.',
    'adv.5.title': 'Durability',
    'adv.5.desc': 'Resistant to the climate and conditions of your location, with minimal maintenance.',
    'adv.6.title': 'Adaptability',
    'adv.6.desc': 'Easy to expand, modify, or even dismantle in the future.',
    // Process
    'proc.title': 'Our Process',
    'proc.1.title': '1. Initial consultation',
    'proc.1.desc': 'We listen to your project and needs.',
    'proc.2.title': '2. Technical proposal',
    'proc.2.desc': 'Detailed design and budget without obligation.',
    'proc.3.title': '3. Manufacturing',
    'proc.3.desc': 'Specialized production in our workshop.',
    'proc.4.title': '4. Delivery',
    'proc.4.desc': 'Installation and delivery on time and in form.',
    // Contact
    'contact.title': 'Quote Your Project',
    'contact.subtitle': 'Tell us what you need and we will give you a proposal without obligation.',
    'contact.email': 'Email',
    'contact.phone': 'Phones',
    'contact.location': 'Location',
    'contact.map': 'View Location on Map',
    'contact.trust1.title': 'Legally constituted company',
    'contact.trust1.desc': 'Operating formally, offering real guarantees in every project.',
    'contact.trust2.title': 'Over 10 years in the region',
    'contact.trust2.desc': 'We know the Mixteca region, its conditions, and the logistics needed to deliver on time.',
    'contact.quote': '"The company that builds with you — not just for you."',
    // Footer
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms and Conditions',
    'footer.rights': 'All rights reserved.',
    'footer.close': 'Close',
    // Privacy Modal
    'priv.updated': 'Last updated: January 2025',
    'priv.1.title': '1. Data Controller',
    'priv.1.desc': 'ARCO Techos y Estructuras de la Mixteca, located at Calle 2 de Abril #134, Colonia Antonio de León, Huajuapan de León, Oaxaca, Mexico, is responsible for processing your personal data.',
    'priv.2.title': '2. Personal Data We Collect',
    'priv.2.desc': 'We may collect the following personal data: full name, phone number, email address, address, and data related to your construction or remodeling project.',
    'priv.3.title': '3. Purpose of Processing',
    'priv.3.desc': 'Your personal data will be used to: provide quotes, follow up on projects, send information about our services, and maintain communication related to contracted work.',
    'priv.4.title': '4. Data Protection',
    'priv.4.desc': 'We implement administrative, technical, and physical security measures to protect your personal data against damage, loss, alteration, destruction, or unauthorized use.',
    'priv.5.title': '5. ARCO Rights',
    'priv.5.desc': 'You have the right to Access, Rectify, Cancel, or Oppose the processing of your personal data. To exercise these rights, you can contact us at itzelrojasramirez51@gmail.com.',
    'priv.6.title': '6. Contact',
    'priv.6.desc': 'For any questions or clarifications about this privacy notice, you can contact us at itzelrojasramirez51@gmail.com or by phone at 953 151 3525 and 953 212 7674.',
    // Terms Modal
    'terms.updated': 'Last updated: January 2025',
    'terms.1.title': '1. Acceptance of Terms',
    'terms.1.desc': 'By using this website, you accept these terms and conditions. If you do not agree with any of them, please do not use this site.',
    'terms.2.title': '2. Services Offered',
    'terms.2.desc': 'ARCO Techos y Estructuras de la Mixteca offers design, manufacturing, and installation services for metal structures, curved roofs, ironwork, and domes. Quotes provided are estimates subject to confirmation after project evaluation.',
    'terms.3.title': '3. Quotes and Prices',
    'terms.3.desc': 'Prices and quotes are valid for the period specified in each document. Prices may vary depending on market conditions, materials, and project specifications.',
    'terms.4.title': '4. Intellectual Property',
    'terms.4.desc': 'All content on this website, including texts, images, logos, and designs, is the property of ARCO Techos y Estructuras de la Mixteca and is protected by applicable intellectual property laws.',
    'terms.5.title': '5. Limitation of Liability',
    'terms.5.desc': 'The information contained on this website is for informational purposes. ARCO Techos y Estructuras de la Mixteca is not responsible for decisions made based on the information presented here without prior direct consultation.',
    'terms.6.title': '6. Contact',
    'terms.6.desc': 'For any inquiries about these terms, you can contact us at itzelrojasramirez51@gmail.com or by phone at 953 151 3525 and 953 212 7674.'
  }
};
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language | null>(null);
  // Check localStorage on mount
  useEffect(() => {
    const savedLang = localStorage.getItem('site_language') as Language;
    if (savedLang === 'es' || savedLang === 'en') {
      setLanguage(savedLang);
    }
  }, []);
  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('site_language', lang);
  };
  const t = (key: string): string => {
    if (!language) return '';
    // @ts-ignore
    return translations[language][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage: handleSetLanguage,
    t
  }} data-id="element-209">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}